module.exports = __webpack_public_path__ + "static/media/filter-name.8ac0b404.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter-name.png
// module id = 476
// module chunks = 0